import RmSetDriverCardModal from './rm-set-driver-card-modal.vue'
export default RmSetDriverCardModal
